import React, { Component, Fragment, useState } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem, FormWrapperInputComponent,
} from "../../../../common/component/Index";
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS, ORDER, TAGGROUP } from "../../../../../../constants/Define";
import { isEqual, get, cloneDeep, find, toArray, merge, difference, isEqualWith, intersection, isNull } from 'lodash';
import * as Func from '../../../../../../helpers/functions';
import TagGroupDetail from '../../../../../../models/TagGroupDetail';
import Wrapper from './../../../../common/component/Wrapper';
import { Checkbox, Icon, Tabs, Modal, DatePicker } from 'antd';
import moment from 'moment';
import './TagGroupDetailLinkSku.less';
import 'react-dual-listbox/lib/react-dual-listbox.css'
import { checkUndefine } from "../../../../../../helpers/functions";
import DEFINE from '../../../../../../constants/Define';
import classNames from 'classnames'
import Button from '../../../../common/component/Button';
import DualListBox from 'react-dual-listbox';
import { fillHotelNameForRatePlan } from '../../../../../../utils/commonUtils';
import { safeSetInnerHTML } from '../../../../../../utils/sanitizeHTML';

const { TabPane } = Tabs;

let permisionActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    isSubmit: false,
    isGetItem: false,
    validation: {},
};

const SkuTypes = [
    ORDER.TYPES.VOUCHER,
    ORDER.TYPES.TOUR,
    ORDER.TYPES.VINWONDER,
    ORDER.TYPES.HOTEL,
    TAGGROUP.TYPES.RATETAG,
]

export default class TagGroupDetailLinkSku extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            tagGroupDetail: cloneDeep(this.props.tagGroupDetailState.detail.tagGroupDetail),
            activeType: ORDER.TYPES.VOUCHER.key,
            allRatePlan: [],

            expiredDate: moment(),

            isModalOpen: false,
            currentOption: null,
            changedOption: [],

            isHotelModalOpen: false,
            hotelCurrentOption: null,
            hotelChangedOption: [],
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TAG_GROUP_DETAIL);
        this.initDetail()
    }

    initDetail() {
        const { match, tagGroupDetailState } = this.props;
        const { activeType } = this.state;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getTagGroupDetailItem(id)
            this.props.getAllSku(activeType)
            this.props.getAllHotel();
        }
    }

    componentWillUnmount() {
        this.props.setTagGroupDetailItem(new TagGroupDetail())
    }

    componentWillReceiveProps(nextProps) {
        const { activeType } = this.state;
        if (nextProps.tagGroupDetailState.detail.tagGroupDetail && !isEqual(nextProps.tagGroupDetailState.detail.tagGroupDetail, this.state.tagGroupDetail)) {
            this.setState({ tagGroupDetail: cloneDeep(nextProps.tagGroupDetailState.detail.tagGroupDetail) });
        }
        if(nextProps.rateState.dataListRateByHotels && !isEqual(nextProps.rateState.dataListRateByHotels, this.state.allRatePlan)){
            this.setState({
                allRatePlan: fillHotelNameForRatePlan({
                    allHotels: this.props.hotelState.allHotels,
                    dataListRateByHotels: nextProps.rateState.dataListRateByHotels,
                }),
            });
        }
        if (activeType === 'rateTag') {
            this.customOption();
        } else if (activeType === 'hotel') {
            this.hotelCustomOption();
        }
    }

    render() {
        const { t, tagGroupDetailState, rateState } = this.props;
        const { isFetchingDetail } = tagGroupDetailState;
        const { isFetchingRatesByHotels } = rateState;
        const { action, isSubmit, isGetItem, validation, tagGroupDetail, activeType, allRatePlan } = this.state;

        const showModal = () => {
            this.setState({ isModalOpen: true });
        };
        const handleOk = () => {
            this.setState({ isModalOpen: false });
            const currentOption = document.querySelector('option[value="' + this.state.currentOption + '"]');
            if (currentOption) {
                let innerHtml = currentOption.innerHTML;
                let matches = innerHtml.match(/\&nbsp\;\-\&nbsp\;🕘\&nbsp\;(.*?)\&nbsp\;/);
                let expiredDate = moment(this.state.expiredDate).format('DD/MM/YYYY');
                if (expiredDate === 'Invalid date') {
                    expiredDate = null;
                }
                if (matches) {
                    var submatch = matches[1];
                    if (expiredDate === null) {
                        innerHtml = currentOption.getAttribute("value").split(":")[1] + "&nbsp;-&nbsp;&#128344;";
                    } else {
                        if (submatch.length < 10) {
                            innerHtml = innerHtml.substring(0, innerHtml.length - 1) + expiredDate + ")";
                        } else {
                            innerHtml = innerHtml.replace(submatch, expiredDate);
                        }
                    }
                    safeSetInnerHTML(currentOption, innerHtml);
                    currentOption.setAttribute("data-expired-date", expiredDate);
                } else {
                    if (expiredDate === null) {
                        innerHtml = currentOption.getAttribute("value").split(":")[1] + "&nbsp;-&nbsp;&#128344;";
                    } else {
                        if (innerHtml.indexOf("&nbsp;-&nbsp;") === -1) {
                            innerHtml += "&nbsp;-&nbsp;&#128344;";
                        }
                        innerHtml += "&nbsp;" + expiredDate + "&nbsp;";
                    }
                    safeSetInnerHTML(currentOption, innerHtml);
                    currentOption.setAttribute("data-expired-date", expiredDate);
                }
                let name = currentOption.getAttribute("value").split(":")[1];
                let skuId = currentOption.getAttribute("value").split(":")[0];
                let changedOptionArray = this.state.changedOption;
                let exist = false;
                changedOptionArray.forEach((item, i) => {
                    if (item.name === name && item.skuId === skuId) {
                        exist = true;
                        changedOptionArray[i] = {
                            name: item.name,
                            dataExpiredDate: expiredDate,
                            skuId: skuId,
                        }
                    }
                })
                if (!exist) {
                    changedOptionArray.push({
                        name: name,
                        dataExpiredDate: expiredDate,
                        skuId: skuId,
                    });
                }
                this.setState({changedOption: changedOptionArray});
            }
        };
        const handleCancel = () => {
            this.setState({ isModalOpen: false });
        };
        const onChange = (date, dateString) => {
            this.setState({expiredDate: date});
        };

        const showHotelModal = () => {
            this.setState({ isHotelModalOpen: true });
        };
        const hotelHandleOk = () => {
            this.setState({ isHotelModalOpen: false });
            const currentOption = document.querySelector('option[value="' + this.state.hotelCurrentOption + '"]');
            if (currentOption) {
                let innerHtml = currentOption.innerHTML;
                let matches = innerHtml.match(/\&nbsp\;\-\&nbsp\;🕘\&nbsp\;(.*?)\&nbsp\;/);
                let expiredDate = moment(this.state.expiredDate).format('DD/MM/YYYY');
                if (expiredDate === 'Invalid date') {
                    expiredDate = null;
                }
                let name = currentOption.getAttribute("value");
                let changedOptionArray = this.state.hotelChangedOption;
                let exist = false;
                changedOptionArray.forEach((item, i) => {
                    if (item.name === name) {
                        exist = true;
                        changedOptionArray[i] = {
                            name: item.name,
                            dataExpiredDate: expiredDate,
                        }
                    }
                })
                if (!exist) {
                    changedOptionArray.push({
                        name: name,
                        dataExpiredDate: expiredDate,
                    });
                }
                this.setState({hotelChangedOption: changedOptionArray});

                if (matches) {
                    var submatch = matches[1];
                    if (expiredDate === null) {
                        if (currentOption.getAttribute("data-inner")) {
                            innerHtml = currentOption.getAttribute("data-inner");
                            const lastChar = innerHtml.slice(-22);
                            if (lastChar === '&nbsp;-&nbsp;&#128344;') {
                                innerHtml = innerHtml.slice(0, -22);
                            }
                        } else {
                            if (currentOption.innerHTML.indexOf('/') !== -1) {
                                innerHtml = currentOption.innerHTML.replace(submatch, "");
                            } else {
                                innerHtml = currentOption.innerHTML;
                            }
                        }
                    } else {
                        innerHtml = innerHtml.replace(submatch, expiredDate);
                    }
                    safeSetInnerHTML(currentOption, innerHtml);
                    currentOption.setAttribute("data-expired-date", expiredDate);
                } else {
                    if (expiredDate === null) {
                        if (currentOption.getAttribute("data-inner")) {
                            innerHtml = currentOption.getAttribute("data-inner");
                        } else {
                            innerHtml = currentOption.innerHTML;
                        }
                    } else {
                        innerHtml += "&nbsp;" + expiredDate + "&nbsp;";
                    }
                    safeSetInnerHTML(currentOption, innerHtml);
                    currentOption.setAttribute("data-expired-date", expiredDate);
                }
            }
        };
        const hotelHandleCancel = () => {
            this.setState({ isHotelModalOpen: false });
        };
        const hotelOnChange = (date, dateString) => {
            this.setState({expiredDate: date});
        };

        document.oncontextmenu = (e) => {
            const rateTagPane = document.querySelector('.ant-tabs-tabpane-active[data-key="rateTag"] .rdl-selected select');
            const hotelTagPane = document.querySelector('.ant-tabs-tabpane-active[data-key="hotel"] .rdl-selected select');
            const currentTarget = e.target;
            if (rateTagPane && rateTagPane.contains(currentTarget) && currentTarget.hasAttribute('data-index')) {
                e.preventDefault();
                const expiredDate = currentTarget.getAttribute("data-expired-date") || null;
                const value = currentTarget.getAttribute("value");
                let formatExpiredDate = moment(expiredDate, "DD/MM/YYYY");
                let matchs = currentTarget.innerHTML.match(/\&nbsp\;\-\&nbsp\;🕘\&nbsp\;(.*?)\&nbsp\;/);
                if (matchs) {
                    formatExpiredDate = moment(matchs[1], "DD/MM/YYYY");
                }
                this.setState({expiredDate: formatExpiredDate});
                this.setState({currentOption: value});
                showModal();
            } else if (hotelTagPane && hotelTagPane.contains(currentTarget) && currentTarget.hasAttribute('data-index')) {
                e.preventDefault();
                const expiredDate = currentTarget.getAttribute("data-expired-date") || null;
                const value = currentTarget.getAttribute("value");
                let formatExpiredDate = moment(expiredDate, "DD/MM/YYYY");
                let matchs = currentTarget.innerHTML.match(/\&nbsp\;\-\&nbsp\;🕘\&nbsp\;(.*?)\&nbsp\;/);
                if (matchs) {
                    formatExpiredDate = moment(matchs[1], "DD/MM/YYYY");
                }
                this.setState({expiredDate: formatExpiredDate});
                this.setState({hotelCurrentOption: value});
                showHotelModal();
            }
        }

        const isSkuChanged = !isEqualWith(tagGroupDetail.tagGroupDetailSkus, get(tagGroupDetailState, 'detail.tagGroupDetail.tagGroupDetailSkus'), item => item.id);
        return (
            <LoadingComponent spinning={isFetchingDetail || isFetchingRatesByHotels}>
                <PageListComponent className="taggroupdetail-linksku-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'categories'}
                        titleHeader={
                            Func.capitalizeFirstLetter((`${t('action.linkSkus')} ${t('item.tagGroupDetails.title')}`).toLowerCase())
                        }
                    />
                    <Tabs activeKey={activeType} onChange={this.onChangeType} type="card" >
                        {SkuTypes.map(item => (
                            <TabPane tab={item.key === 'rateTag' ? t(`item.tagGroupDetails.${item.key}`) : t(`item.order.orderTypes.${item.key}`)} key={item.key} className="bg-white pt-3 px-3" data-key={item.key}>
                                <FormActionComponent
                                    marginTop={0}
                                    onSubmit={this.onSubmit}
                                    isSubmit={isSubmit}
                                    action={action}
                                    isGetItem={isGetItem}
                                    onClickBack={this.onClickBack}
                                    backButtonText={t(`action.back`)}
                                    titleButtonSubmit={t(`action.save`)}
                                    submitButtonRight={permisionActions && permisionActions.allowMapSku}
                                    // propsButtonSubmit={{ disabled: !isSkuChanged }}
                                >
                                    <Wrapper className='w-100'>
                                        {
                                            item.key === 'rateTag' ?
                                            <DualListBox
                                                canFilter showHeaderLabels
                                                filterPlaceholder={t('action.search')}
                                                options={
                                                    (allRatePlan || []).map(item => (
                                                        {
                                                            label: item.name,
                                                            options: item.ratePlans.map(itemRate => ({
                                                                ...itemRate,
                                                                label: itemRate.code + (this.renderExpiredDate(itemRate, item.id)),
                                                                value: `${ item.id }:${ itemRate.code }`,
                                                            })),
                                                        }))
                                                }
                                                selected={this.getSelectedRateTag(item)}
                                                onChange={this.onChangeSkusRateTag}
                                                filterCallback={this.onFilter}
                                                lang={{
                                                    availableHeader: t('item.tagGroupDetails.rateTagAvailable'),
                                                    selectedHeader: t('item.tagGroupDetails.rateTagSelected'),
                                                }}
                                                icons={{
                                                    moveLeft: <Icon type="left" className="mx-2" />,
                                                    moveAllLeft: <Icon type="double-left" className="mx-2" />,
                                                    moveRight: <Icon type="right" className="mx-2" />,
                                                    moveAllRight: <Icon type="double-right" className="mx-2" />,
                                                }}
                                            />
                                            : <DualListBox
                                                canFilter showHeaderLabels
                                                filterPlaceholder={t('action.search')}
                                                options={(tagGroupDetailState.skus[item.key] || []).map(item => merge(item, {
                                                    label: activeType === 'hotel' ? `[${item.code}] ${item.name}` + this.hotelRenderExpiredDate(item) : `[${item.code}] ${item.name}`,
                                                    value: item.id
                                                }))}
                                                selected={this.getSelectedIds(item)}
                                                onChange={this.onChangeSkus}
                                                filterCallback={this.onFilter}
                                                lang={{
                                                    availableHeader: t('item.tagGroupDetails.skuAvailable'),
                                                    selectedHeader: t('item.tagGroupDetails.skuSelected'),
                                                }}
                                                icons={{
                                                    moveLeft: <Icon type="left" className="mx-2" />,
                                                    moveAllLeft: <Icon type="double-left" className="mx-2" />,
                                                    moveRight: <Icon type="right" className="mx-2" />,
                                                    moveAllRight: <Icon type="double-right" className="mx-2" />,
                                                }}
                                            />
                                        }
                                    </Wrapper>
                                </FormActionComponent>
                            </TabPane>
                        ))}
                    </Tabs>
                </PageListComponent>

                <Modal title="Update expired date" visible={this.state.isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                    <DatePicker
                        value={isNaN(this.state.expiredDate) ? null : this.state.expiredDate}
                        format="DD/MM/YYYY"
                        onChange={onChange}
                        disabledDate={d => !d || d.isBefore(moment().subtract(1, 'days'))}
                    />
                </Modal>

                <Modal title="Update expired date" visible={this.state.isHotelModalOpen} onOk={hotelHandleOk} onCancel={hotelHandleCancel}>
                    <DatePicker
                        value={isNaN(this.state.expiredDate) ? null : this.state.expiredDate}
                        format="DD/MM/YYYY"
                        onChange={hotelOnChange}
                        disabledDate={d => !d || d.isBefore(moment().subtract(1, 'days'))}
                    />
                </Modal>
            </LoadingComponent>
        );
    }


    onChange = (fieldName, value) => {
        const tagGroupDetail = cloneDeep(this.state.tagGroupDetail);
        tagGroupDetail[fieldName] = value.trimLeft();
        this.setState({ tagGroupDetail });
    };

    onChangeType = (key) => {
        this.props.mapSkuSuccess();
        const { tagGroupDetailState, rateState } = this.props;
        this.setState({ activeType: key });
        if(key === 'rateTag'){
            if(!rateState.dataListRateByHotels.length){
                const { hotelState } = this.props;
                const { allHotels } = hotelState;
                this.props.getListRatesByHotels({
                    hotelIds: (allHotels || []).map(item => item.id),
                    dc: [],
                });
            }
        }else{
            const skus = tagGroupDetailState.skus[key] || []
            if (!skus.length) {
                this.props.getAllSku(key)
            }
        }
    }

    onChangeSkus = (selectedIds) => {
        const tagGroupDetail = cloneDeep(this.state.tagGroupDetail);
        const { activeType } = this.state;
        tagGroupDetail.tagGroupDetailSkus = selectedIds.map((id) => {
            if (activeType === 'hotel') {
                setTimeout(() => {
                    let opt = document.querySelector('.rdl-selected option[value="' + id + '"]');
                    if (opt && opt.innerHTML.indexOf("🕘") === -1) {
                        safeSetInnerHTML(opt, opt.innerHTML + "&nbsp;-&nbsp;&#128344;");
                    }
                    const hotelChangedOption = this.state.hotelChangedOption;
                    hotelChangedOption.forEach((option) => {
                        if (option.name === id && opt) {
                            let matches = opt.innerHTML.match(/\&nbsp\;\-\&nbsp\;🕘\&nbsp\;(.*?)\&nbsp\;/);
                            if (option.dataExpiredDate) {
                                if (!matches || !matches[1]) {
                                    safeSetInnerHTML(opt, opt.innerHTML + "&nbsp;" + option.dataExpiredDate + "&nbsp;");
                                }
                            } else {
                                if (matches && matches[1]) {
                                    safeSetInnerHTML(opt, opt.innerHTML.replace(matches[1], ""));
                                }
                            }
                        }
                    });
                }, 0);
            }
            return { skuId: id }
        })
        this.setState({ tagGroupDetail });
    }

    onChangeSkusRateTag = (selectedIds) => {
        const tagGroupDetail = cloneDeep(this.state.tagGroupDetail);
        const mapHotelRatePlan = selectedIds.map(itemRateCode => {
            setTimeout(() => {
                let opt = document.querySelector('option[value="' + itemRateCode + '"]');
                if (opt && opt.innerHTML.indexOf("🕘") === -1) {
                    safeSetInnerHTML(opt, opt.innerHTML + "&nbsp;-&nbsp;&#128344;");
                }
                const changedOption = this.state.changedOption;
                changedOption.forEach((option) => {
                    if (opt && option.skuId === itemRateCode.split(':')[0] && option.name === itemRateCode.split(':')[1]) {
                        let matches = opt.innerHTML.match(/\&nbsp\;\-\&nbsp\;🕘\&nbsp\;(.*?)\&nbsp\;/);
                        if (option.dataExpiredDate) {
                            if (!matches || !matches[1]) {
                                safeSetInnerHTML(opt, opt.innerHTML + "&nbsp;" + option.dataExpiredDate + "&nbsp;");
                            }
                        } else {
                            if (matches && matches[1]) {
                                safeSetInnerHTML(opt, opt.innerHTML.replace(matches[1], ""));
                            }
                        }
                    }
                });
            }, 0)
            let hotelId = '';
            let rateCode = '';
            const arrRateCode = itemRateCode.split(':');
            if (arrRateCode && arrRateCode.length > 0) {
                hotelId = arrRateCode[0];
                rateCode = arrRateCode[1];
            }
            return {
                id: hotelId,
                rateCodes: rateCode
            }
        })
        tagGroupDetail.tagGroupDetailSkus = Array.from(new Set(mapHotelRatePlan.map(s => s.id)))
            .map(lab => {
                return {
                    skuId: lab,
                    rateCodes: mapHotelRatePlan.filter(s => s.id === lab).map(edition => edition.rateCodes)
                }
            })
        this.setState({ tagGroupDetail });
    }

    onFilter = (option, filterInput) => {
        if (filterInput === '') {
            return true;
        }
        if (!isNull(option.label)) {
            const optionText = Func.vietnameseStringToUnicode(option?.label.toLowerCase());
            const inputText = Func.vietnameseStringToUnicode(filterInput.toLowerCase());
            return optionText.indexOf(inputText) >= 0 || optionText.indexOf(inputText) >= 0;
        }
    }

    onClickBack = () => {
        const path = Func.getPathWithParams(PATHS.TAG_GROUP_DETAIL.DETAIL.path, { id: get(this.props, 'match.params.id') })
        this.props.history.push(path);
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { tagGroupDetailState } = this.props;
        const { tagGroupDetail, activeType } = this.state;
        const selectedSkuType = SkuTypes.find(item => item.key === activeType);
        const tagGroupDetailId = get(this.props, 'match.params.id');
        const originIds = (get(tagGroupDetailState, 'detail.tagGroupDetail.tagGroupDetailSkus') || [])
            .filter(item => item.type === selectedSkuType.id)
            .map(item => item.skuId);
        let selectedIds = this.getSelectedIds(selectedSkuType, true);
        if(activeType === 'rateTag'){
            selectedIds = this.getSelectedRateTag(selectedSkuType, true);
        }
        const inserts = difference(selectedIds, originIds);
        const deletes = difference(originIds, selectedIds);
        let params = { tagGroupDetailId, inserts, deletes, typeId: selectedSkuType.id }
        if(activeType === 'rateTag'){
            selectedIds = selectedIds.map((item) => {
                return {
                    skuId: item,
                    expiredDate: null
                };
            })

            const hotelRatePlans = this.renderHotelRatePlans();
            params = {
                ...params,
                inserts: selectedIds,
                deletes: deletes,
                // hotelRatePlans: tagGroupDetail.tagGroupDetailSkus
                hotelRatePlans: hotelRatePlans
            }
        } else {
            const hotelChangedOption = this.state.hotelChangedOption;
            let insertedItem = [];
            let newInserts = inserts.map((item) => {
                insertedItem.push(item);
                let newItem = {
                    skuId: item,
                    ExpiredDate: null
                };
                if (activeType == 'hotel') {
                    hotelChangedOption.forEach((changedOption) => {
                        if (item === changedOption.name) {
                            if (changedOption.dataExpiredDate !== null) {
                                newItem.ExpiredDate = moment(changedOption.dataExpiredDate, 'DD/MM/YYYY').format("YYYY-MM-DD") + "T00:00:00Z";
                            }
                        }
                    });
                }
                return newItem;
            });
            if (activeType == 'hotel') {
                hotelChangedOption.forEach((changedOption) => {
                    if (insertedItem.indexOf(changedOption.name) === -1) {
                        if (changedOption.dataExpiredDate !== null) {
                            newInserts.push({
                                skuId: changedOption.name,
                                ExpiredDate: moment(changedOption.dataExpiredDate, 'DD/MM/YYYY').format("YYYY-MM-DD") + "T00:00:00Z",
                            });
                        } else {
                            newInserts.push({
                                skuId: changedOption.name,
                                ExpiredDate: null,
                            });
                        }
                    }
                });
            }
            params = {
                ...params,
                inserts: newInserts,
            }
        }
        this.setState({hotelChangedOption: []});
        this.setState({changedOption: []});
        this.props.mapSku(params);
    };

    renderExpiredDate = (input, skuId) => {
        const { tagGroupDetail } = this.state;
        let expiredDate = null;
        let check = true;
        if (check) {
            tagGroupDetail.__data__.tagGroupDetailSkus.forEach((tagGroup) => {
                if (tagGroup.skuId === skuId && tagGroup.expiredDateRate && tagGroup.expiredDateRate.length > 0) {
                    tagGroup.expiredDateRate.forEach((rate) => {
                        if (input.code === rate.rateCode) {
                            check = false;
                            if (rate.expiredDate && rate.expiredDate != null) {
                                expiredDate = moment(rate.expiredDate).format("DD/MM/YYYY");
                            }
                        }
                    })
                }
            })
        }

        let string = expiredDate || "";
        if (!check) {
            if (expiredDate !== null) {
                string = "&nbsp;-&nbsp;&#128344;&nbsp;" + expiredDate + "&nbsp;";
            } else {
                string = "&nbsp;-&nbsp;&#128344;";
            }
        }
        var doc = new DOMParser().parseFromString(string, "text/html");
        return doc.documentElement.textContent;
    }

    hotelRenderExpiredDate = (input) => {
        const { tagGroupDetailState } = this.props;
        let expiredDate = null;
        let check = true;
        tagGroupDetailState.detail.tagGroupDetail.__data__.tagGroupDetailSkus.forEach((tagGroup) => {
            if (check) {
                if (tagGroup.skuId === input.id && tagGroup.type === 4) {
                    check = false;
                    if (tagGroup.expiredDateSku && tagGroup.expiredDateSku != null) {
                        expiredDate = moment(tagGroup.expiredDateSku).format("DD/MM/YYYY");
                    }
                }
            }
        });

        let string = "";
        if (!check) {
            if (expiredDate !== null) {
                string = "&nbsp;-&nbsp;&#128344;&nbsp;" + expiredDate + "&nbsp;";
            } else {
                string = "&nbsp;-&nbsp;&#128344;";
            }
        }
        var doc = new DOMParser().parseFromString(string, "text/html");
        return doc.documentElement.textContent;
    }

    renderHotelRatePlans = () => {
        const { tagGroupDetail } = this.state;
        let hotelRatePlans = [];
        tagGroupDetail.tagGroupDetailSkus.forEach((changedItem) => {
            if (changedItem.rateCodes) {
                const skuId = changedItem.skuId;
                let hotelRatePlanObj = {
                    skuId: skuId,
                    rateCodes: [],
                };
                changedItem.rateCodes.forEach((changedRateCode) => {
                    let newItem = {
                        rateCode: changedRateCode,
                        expiredDate: null,
                    }
                    if (tagGroupDetail.__data__.tagGroupDetailSkus && tagGroupDetail.__data__.tagGroupDetailSkus.length > 0) {
                        tagGroupDetail.__data__.tagGroupDetailSkus.forEach((originItem) => {
                            if (originItem.skuId === skuId && originItem.rateCodes && originItem.expiredDateRate) {
                                const expiredDateRate = originItem.expiredDateRate;
                                originItem.rateCodes.forEach((rateCode) => {
                                    if (changedRateCode === rateCode) {
                                        expiredDateRate.forEach((rate) => {
                                            if (rate.rateCode === rateCode) {
                                                newItem.expiredDate = rate.expiredDate;
                                                const changedOption = this.state.changedOption;
                                                changedOption.forEach((opt) => {
                                                    if (rateCode === opt.name && skuId === opt.skuId) {
                                                        if (opt.dataExpiredDate === null) {
                                                            newItem.expiredDate = null;
                                                        } else {
                                                            newItem.expiredDate = moment(opt.dataExpiredDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                                        }
                                                    }
                                                })
                                            }
                                        });
                                    } else {
                                        const changedOption = this.state.changedOption;
                                        changedOption.forEach((opt) => {
                                            if (changedRateCode === opt.name && skuId === opt.skuId) {
                                                if (opt.dataExpiredDate === null) {
                                                    newItem.expiredDate = null;
                                                } else {
                                                    newItem.expiredDate = moment(opt.dataExpiredDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                                }
                                            }
                                        })
                                    }
                                });
                            } else {
                                const changedOption = this.state.changedOption;
                                changedOption.forEach((opt) => {
                                    if (changedRateCode === opt.name && skuId === opt.skuId) {
                                        if (opt.dataExpiredDate === null) {
                                            newItem.expiredDate = null;
                                        } else {
                                            newItem.expiredDate = moment(opt.dataExpiredDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                        }
                                    }
                                })
                            }
                        });
                    } else {
                        const changedOption = this.state.changedOption;
                        changedOption.forEach((opt) => {
                            if (changedRateCode === opt.name && skuId === opt.skuId) {
                                if (opt.dataExpiredDate === null) {
                                    newItem.expiredDate = null;
                                } else {
                                    newItem.expiredDate = moment(opt.dataExpiredDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                                }
                            }
                        })
                    }
                    hotelRatePlanObj.rateCodes.push(newItem);
                });
                hotelRatePlans.push(hotelRatePlanObj);
            }
        });
        return hotelRatePlans;
    };

    customOption = () => {
        const opts = document.querySelectorAll('[data-key="rateTag"] .rdl-selected option');
        if (opts && opts.length) {
            opts.forEach((item) => {
                let innerHtml = item.innerHTML;
                let matches = innerHtml.match(/\&nbsp\;\-\&nbsp\;🕘\&nbsp\;(.*?)\&nbsp\;/);
                if (matches) {
                    var submatch = matches[1];
                    item.setAttribute("data-expired-date", submatch);
                } else {
                    item.setAttribute("data-expired-date", null);
                }
            })
        } else {
            setTimeout(() => {
                this.customOption();
            }, 1000);
        }
    };

    hotelCustomOption = () => {
        const opts = document.querySelectorAll('[data-key="hotel"] .rdl-selected option');
        if (opts && opts.length) {
            opts.forEach((item) => {
                let innerHtml = item.innerHTML;
                let code = innerHtml.match(/\[(.*?)\]/)[1];
                let originInnerHtml = innerHtml.match(/\&nbsp\;\-\&nbsp\;🕘\&nbsp\;(.*?)\&nbsp\;/);
                if (originInnerHtml) {
                    item.setAttribute('data-inner', innerHtml.replace(originInnerHtml[0], "") + "&nbsp;-&nbsp;&#128344;");
                } else {
                    item.setAttribute('data-inner', innerHtml + "&nbsp;-&nbsp;&#128344;");
                }
                item.setAttribute('data-code', code);
                let matches = innerHtml.match(/\&nbsp\;\-\&nbsp\;🕘\&nbsp\;(.*?)\&nbsp\;/);
                if (matches) {
                    var submatch = matches[1];
                    item.setAttribute("data-expired-date", submatch);
                } else {
                    item.setAttribute("data-expired-date", null);
                }
            })
        } else {
            setTimeout(() => {
                this.hotelCustomOption();
            }, 1000);
        }
    };

    hasSomeParentTheClass = (element, classname) => {
        return element.parentNode && this.hasSomeParentTheClass(element.parentNode, classname);
    }

    getSelectedSkus = (skuItemEnum) => {
        const { tagGroupDetail } = this.state;
        return tagGroupDetail.tagGroupDetailSkus.filter(item => !item.type || !skuItemEnum || item.type === skuItemEnum.id)
    }

    getSelectedIds = (skuItemEnum, withIntersection = false) => {
        const { tagGroupDetailState } = this.props;
        const selectedSkus = this.getSelectedSkus(skuItemEnum)
        const selectedIds = selectedSkus.map(item => item.skuId)
        if (!withIntersection) {
            return selectedIds
        }
        const allIds = (tagGroupDetailState.skus[skuItemEnum.key] || []).map(item => item.id)
        return intersection(selectedIds, allIds)
    }

    getSelectedRateTag = (skuItemEnum, withIntersection = false) => {
        const { tagGroupDetailState } = this.props;
        const selectedSkus = this.getSelectedSkus(skuItemEnum);
        const selectedIds = selectedSkus.map(item => item.skuId);
        const hotels = [];
        const arrRateCodes = [];
        selectedSkus.map(item => {
            if (hotels && !hotels.includes(item.id))
                hotels.push(item.id);
            const rateCodes = item.rateCodes;
            if (rateCodes && rateCodes.length > 0) {
                rateCodes.map(itemRate => {
                    arrRateCodes.push(`${ item.skuId }:${ itemRate }`);
                })
            }
        });
        if (!withIntersection) {
            return arrRateCodes;
        }
        return selectedIds;
    }
}
